import { render, staticRenderFns } from "./Levet.vue?vue&type=template&id=7972e2b6&lang=html&"
import script from "./Levet.vue?vue&type=script&lang=js&"
export * from "./Levet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports